<script setup>
import { ref } from 'vue';
import FordLogo from '@/components/FordLogo.vue';
import EventIcon from '@/components/EventIcon.vue';
import ScaleInOutCenter from '@/components/transitions/ScaleInOutCenter.vue';
import { faBellExclamation } from '@fortawesome/pro-solid-svg-icons';
import { useStore } from 'vuex';

import { faBars, faTimes } from '@fortawesome/pro-regular-svg-icons';

defineProps({ eventTypes: Array });

const navDrawerOpen = ref(false);

const toggleBodyClass = () => {
  const el = document.body;
  if (navDrawerOpen.value === true) {
    el.classList.add('overflow-hidden');
  } else {
    el.classList.remove('overflow-hidden');
  }
};

const toggleNavDrawer = () => {
  navDrawerOpen.value = !navDrawerOpen.value;
  toggleBodyClass();
};
const closeNavDrawer = () => {
  navDrawerOpen.value = false;
  toggleBodyClass();
};

const store = useStore();
const setEventType = (id) => {
  closeNavDrawer();
  store.commit('home/setEventType', id);
};

const emit = defineEmits(['notify']);

const notify = () => {
  closeNavDrawer();
  emit('notify');
};
</script>

<template>
  <nav
    class="
      container-xxl
      relative
      h-14
      font-FordAntennaSemiBold
      text-[0.5rem]
      tracking-[0.04em]
      uppercase
      tablet:h-24
      tablet:text-xs
      tablet:flex
      tablet:items-center
      tablet:px-3
      tablet:divide-x-4
      tablet:divide-ford-gray-light
      desktop:h-32 desktop:text-base
      desktop-lg:text-lg
      desktop-xxl:px-[90px]
    "
  >
    <div
      class="
        bg-white
        h-full
        flex
        items-center
        justify-between
        relative
        z-50
        px-3
        tablet:pl-0 tablet:pr-5
        desktop:pr-6
      "
    >
      <router-link
        to="/"
        @click="() => setEventType('')"
        class="flex items-center space-x-2 tablet:space-x-3 desktop:space-x-4"
      >
        <ford-logo class="w-11 tablet:w-20 desktop:w-24" />
        <div>Events</div>
      </router-link>
      <button
        @click="toggleNavDrawer"
        class="w-8 h-8 pt-1 text-xl tablet:hidden"
      >
        <scale-in-out-center>
          <font-awesome-icon v-if="!navDrawerOpen" key="1" :icon="faBars" />
          <font-awesome-icon v-else key="2" :icon="faTimes" />
        </scale-in-out-center>
      </button>
    </div>
    <div class="tablet:pl-5 desktop:pl-6 flex-1">
      <div
        :class="navDrawerOpen ? 'top-14' : '-top-[3.75rem]'"
        class="
          absolute
          w-full
          bg-white
          border-t border-t-[#00000029]
          transition-top
          duration-300
          ease-in-out
          flex
          justify-center
          px-4
          tablet:px-0 tablet:relative tablet:top-auto tablet:border-none
        "
      >
        <ul
          class="
            w-[24.5rem]
            flex flex-wrap gap-x-14
            items-center
            z-40
            tablet:w-full tablet:flex-nowrap
          "
        >
          <li
            v-for="eventType in eventTypes"
            :key="eventType.id"
            class="text-center"
          >
            <router-link
              :to="`/`"
              @click="setEventType(eventType.id)"
              class="
                flex
                items-center
                py-4
                tablet:py-0
                hover:text-ford-blue-electric
              "
            >
              <event-icon
                :type="eventType.name.toLowerCase()"
                class="w-10 mr-3.5 tablet:w-12 desktop:w-16 desktop-lg:mr-6"
              />
              {{ eventType.name }}
            </router-link>
          </li>
          <li
            class="
              text-ford-gray-dark
              w-full
              tablet:w-auto
              desktop-lg:ml-auto
              hover:text-ford-blue-electric
            "
          >
            <button
              v-if="false"
              @click="notify"
              class="uppercase w-full py-4 tablet:w-auto notify-btn"
            >
              <font-awesome-icon
                :icon="faBellExclamation"
                size="2xl"
                class="mr-4 bell-icon"
              />notify me
            </button>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</template>
<style lang="scss" scoped>
.notify-btn {
  &:hover {
    .bell-icon {
      animation: shake 0.3s linear 4;
      transform-origin: 50% 0;
    }
  }
}

@keyframes shake {
  0% {
    transform: rotate(0deg);
  }
  25% {
    transform: rotate(-10deg);
  }
  50% {
    transform: rotate(0deg);
  }
  75% {
    transform: rotate(10deg);
  }
  100% {
    transform: rotate(0deg);
  }
}
</style>
